import {HttpBackend} from '@angular/common/http';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';
import {environment} from '@env/environment';

export function translateHttpFactory(handler: HttpBackend): MultiTranslateHttpLoader {
  const assets = [
    {prefix: './assets/i18n/', suffix: '.json'}
  ];
  // upload separate i18n files from themes
  if (environment.theme !== 'default') {
      assets.push({prefix: `./themes/${environment.theme}/assets/i18n/`, suffix: '.json'});
  }
  return new MultiTranslateHttpLoader(handler, assets);
}
